import clsx from 'clsx';

import { ciFormModule } from '@atom/selectors/formModuleSelectors';
import {
  CiModuleInspectionUpdate,
  FormInstanceFieldItem,
} from '@atom/types/form';
import { Media } from '@atom/types/media';

import CiFieldRow from './CiFieldRow';
import CiScore from './CiScore';

import classes from './ci.module.css';

interface Props {
  field: FormInstanceFieldItem;
  fieldId: string;
  assetId: string;
  media: Media[];
  preview: boolean;
  onChange: (update: CiModuleInspectionUpdate) => void;
  uploadFiles: (
    files?: any[],
    subjectId?: string,
    subjectType?: string,
    inspectionUpdate?: CiModuleInspectionUpdate,
  ) => void;
  removeFile: (mediaId: string, subjectId: string) => void;
  renameMedia: (mediaId: string, subjectId: string, name: string) => void;
  isEditable: boolean;
}

const CiField = ({
  field,
  fieldId,
  assetId,
  preview,
  media,
  onChange,
  uploadFiles,
  renameMedia,
  isEditable,
}: Props) => {
  return (
    <div>
      <div className={classes.container}>
        <div className={classes.header}>
          <div className={classes.titleContainer}>
            {ciFormModule.icon}
            <div className={classes.title}>
              {`${ciFormModule.title}: ${field.name}`}
            </div>
          </div>
          <CiScore />
        </div>
      </div>
      <div className={classes.tableHeader}>
        <div className={classes.largeColumn}>inspection item</div>
        <div className={classes.descriptionColumn}>description</div>
        <div className={clsx(classes.normalColumn, classes.rating)}>
          rating description
        </div>
        <div className={clsx(classes.smallColumn, classes.points)}>
          ci points
        </div>
        <div className={classes.smallColumn}>photos</div>
        <div className={classes.smallColumn}>notes</div>
      </div>
      <div className={classes.tableRowsContainer}>
        {field.inspections.map((inspection, index) => {
          const inspectionMedia = inspection.mediaIds
            ? media.filter(({ id }) => inspection.mediaIds.includes(id))
            : [];

          return (
            <CiFieldRow
              fieldId={fieldId}
              assetId={assetId}
              inspection={inspection}
              inspectionIndex={index}
              media={inspectionMedia}
              onChange={onChange}
              preview={preview}
              key={index}
              uploadFiles={uploadFiles}
              renameMedia={renameMedia}
              isEditable={isEditable}
            />
          );
        })}
      </div>
    </div>
  );
};

export default CiField;
